<template>
  <div class="section-space--ptb_100 bg-expertos">
    <div class="container">
      <!-- Titulo -->
      <div
        class="
          section-title-wrapper
          text-center
          section-space--mb_60
          wow
          move-up
        "
      >
        <h2 class="section-title mb-30 font-weight-bold">
          {{ text_section.title }}
        </h2>
        <div
          class="
            elementor-element elementor-element-79f9810
            elementor-widget-divider--view-line
            elementor-widget elementor-widget-divider
          "
          data-id="79f9810"
          data-element_type="widget"
          data-widget_type="divider.default"
        >
          <div class="elementor-widget-container">
            <div class="elementor-divider">
              <span class="elementor-divider-separator"> </span>
            </div>
          </div>
        </div>

        <span class="section-text wow move-up mt-4">
          {{ text_section.text_description }}
        </span>
      </div>
      <!-- fin Titulo -->

      <!-- Contenedor expertos -->
      <div class="col-lg-12">
        <div class="swiper-container team-slider__container">
          <swiper :options="swiperOption">
            <div
              class="swiper-slide"
              v-for="(instructor, index) in getLimitInstructores"
              :key="index"
            >
              <div
                class="card-instructores p-4"
                @click="redirect_expert(instructor._id)"
              >
                <div
                  class="
                    card-media
                    d-flex
                    justify-content-center
                    align-items-center
                  "
                >
                  <img :src="instructor.img" alt="imagen-instructor" />
                </div>

                <div class="card-content">
                  <div class="name my-2">
                    {{ `${instructor.nombre} ${instructor.apellido}` }}
                  </div>
                  <div class="description">
                    {{ instructor.puesto }}
                  </div>
                </div>
              </div>
            </div>
          </swiper>
          <div
            class="swiper-pagination swiper-pagination-1 section-space--mt_60"
            v-show="mostrar_paginador"
          ></div>
        </div>
      </div>

      <div class="row">
        <div class="col-12 d-flex justify-content-center mt-4">
          <a
            href="https://forumapp.progrentis.com/expertos"
            class="btn btn-primary"
            >Ver todos</a
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import gql from "graphql-tag";

export default {
  name: "NuestrosExpertos",
  components: {},
  data() {
    return {
      text_section: {
        title: "Nuestros expertos",
        text_description:
          "Además de nuestro equipo pedagógico, nuestros cursos cuentan con la participación de un panel internacional de expertos de clase mundial.",
      },
      getLimitInstructores: [],
      mostrar_paginador: false,
      swiperOption: {
        speed: 800,
        loop: true,
        slidesPerView: 3,
        slidesPerColumn: 2,
        spaceBetween: 30,
        autoplay: {
          delay: 2500,
          disableOnInteraction: true,
        },
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        breakpoints: {
          1499: {
            slidesPerView: 3,
          },

          991: {
            slidesPerView: 2,
          },

          767: {
            slidesPerView: 1,
          },

          575: {
            slidesPerView: 1,
          },
        },
      },
    };
  },
  methods: {
    redirect_expert(id) {
      window.location.href = "https://forumapp.progrentis.com/expertos/" + id;
    },
  },
  apollo: {
    getLimitInstructores: {
      query: gql`
        query {
          getLimitInstructores {
            _id
            nombre
            apellido
            img
            descripcion
            puesto
            email
            pais
            destacado
          }
        }
      `,
      pollInterval: 120000,
    },
  },
};
</script>

<style lang="scss" scoped>
.seccion-text {
  font-family: "Mulish";
  font-style: normal;
  font-weight: 500;
  font-size: 20px;
  line-height: 25px;
  text-align: center;
  color: #505565;
}

.bg-expertos {
  background-image: url("../../assets/img/forum/bg-expertos.svg");
  background-size: contain;
  background-repeat: no-repeat;
  background-position: bottom;
}

.card-instructores {
  background: #ffffff;
  border-radius: 16px;
  margin: 10px;
  height: 280px;
  display: flex;
  flex-direction: column;
  box-shadow: -1px 12px 30px -13px rgba(0, 0, 0, 0.27);
  -webkit-box-shadow: -1px 12px 30px -13px rgba(0, 0, 0, 0.27);
  -moz-box-shadow: -1px 12px 30px -13px rgba(0, 0, 0, 0.27);

  .card-media {
    height: 140px;
    width: 100%;
    position: relative;

    img {
      display: block;
      height: 100px;
      border: 5px solid #ffffff;
      border-radius: 50%;
      box-shadow: -1px 12px 30px -13px rgba(0, 0, 0, 0.59);
      -webkit-box-shadow: -1px 12px 30px -13px rgba(0, 0, 0, 0.59);
      -moz-box-shadow: -1px 12px 30px -13px rgba(0, 0, 0, 0.59);
    }
  }

  .card-content {
    .name {
      font-family: "Montserrat";
      font-style: normal;
      font-weight: 500;
      font-size: 22px;
      line-height: 27px;
      text-align: center;
      color: #2c2e30;
    }

    .description {
      font-family: "Montserrat";
      font-style: normal;
      font-weight: 500;
      font-size: 14px;
      line-height: 16px;
      text-align: center;
      color: #aeb7bd;
    }
  }
}
</style>